export const VUE_APP_WX_SIGNATURE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://wapapi.nfapp.southcn.com/nfplus-wap-api/wx/getShareSignInfo'
    : process.env.NODE_ENV === 'test'
      ? 'https://testwapapi.nfnews.com/nfplus-wap-api/wx/getShareSignInfo'
      : 'https://testwapapi.nfnews.com/nfplus-wap-api/wx/getShareSignInfo'
